module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "ultra"
  }, [_vm._v("SOUL SENSE")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_vm._v("Through the hundreds of people I have guided toward the realization of their full potential, and in the hundreds of workshops I have facilitated, one message has emerged universally over others:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We want something in addition to the achievement of goals and results. We are people who aim high and take risks, but we also long to have meaning, live from the highest values and to be grounded. How can we create a more centered, purposeful life and workspace, in this era of constant change, chaos, and minute-by-minute progress?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "sbold"
  }, [_vm._v("Soul Sense is the answer.")]), _vm._v(" The Soul Sense Process™ comprised of Soul Call, Soul Fire and Soul Care that is described in this book puts a name, conscious intent, and practice to Soul-Full living. Listening to your Soul Call, stoking your Soul Fire, and practicing Soul Care brings depth, growth and balance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soul Sense can be thought of as common sense seasoned with the sixth sense. It is what you know as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("good")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("right,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("just")]), _vm._v(" in your personal and professional lives, while embracing the powers of intuition that transcend such definitions. Soul Sense is logical and instinctual, practical and untamed. Developing Soul Sense is a doorway to living your life with elevated consciousness and accountability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tuning into and trusting your Soul Sense brings increasing fulfillment to your life, and to the lives of those around you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The courageous choice to honor your Soul Sense, ultimately, is up to you—and it is my joy and intention to lead you toward this profound gift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-top"
  }, [_c('span', {
    staticClass: "gitalic"
  }, [_vm._v("Your Soul Sense awaits….")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 75
// module chunks = 0